module.exports = __webpack_public_path__ + "img/nav_img_cosmetics_2026.cafc9361.png";